import React from "react";
import MarketingHeader from "./MarketingHeader";
import MobxPageContent from "shared/components/MobxPageContent";
import Propulator from "higher-order/Propulator";
import CookieConsent from "shared/components/CookieConsent";
import MarketingSubfooter from "../components/MarketingSubfooter";

class MarketingPageContent extends React.Component {
    render() {
        const {
            session,
            ...otherProps
        } = this.props;
        const defaultProduct = otherProps?.defaultProduct ?? 1;
        const enableSubfooter = otherProps?.enableSubfooter;
        const legalTextKeys = otherProps?.legalTextKeys ?? [];
        const isLoggedIn = session?.isLoggedIn;
        const requestInfoUrl = this.props.session?.requestInfoUrl;

        const header = (
            <MarketingHeader
                className="header-splash"
                isLoggedIn={isLoggedIn}
                showLoginLink={this.props.showLoginLink}
                requestInfoUrl={requestInfoUrl}
                loginPath={session?.loginPath}
            />);

        return (
            <MobxPageContent {...otherProps} header={header}>
                {this.props.children}
                {enableSubfooter && <MarketingSubfooter defaultProduct={defaultProduct} legalTextKeys={legalTextKeys} requestInfoUrl={requestInfoUrl} />}
                <CookieConsent />
            </MobxPageContent>
        );
    }
}

export default Propulator(MarketingPageContent, {
    sessionStore: {
        session: "session"
    }
});
